import { Form, Input, Button } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IDepositDTO from '../../../dtos/IDepositDTO';
import { useApi } from '../../../hooks/api';
import { useNotification } from '../../../hooks/notification';
import { Container } from './styles';

const validate = {
  required: '${label} é obrigatório',
};

const EditDeposits: React.FC = () => {
  const { api } = useApi();
  const { openNotificationWithIcon } = useNotification();
  const [deposit, setDeposit] = useState<IDepositDTO>();

  const [form] = Form.useForm();

  const { id } = useParams<{ id: string }>();

  const loadData = useCallback(async (): Promise<void> => {
    const depositResponse = await api.get<IDepositDTO>(`deposits/${id}`);

    setDeposit(depositResponse.data);
  }, [api, id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleSubmit = async (data: IDepositDTO): Promise<void> => {
    try {
      await api.put(`deposits/${id}`, data);
      openNotificationWithIcon('success', {
        title: 'Depósito',
        content: 'Depósito alterado com sucesso!',
      });
    } catch (error) {
      let errorMessage;
      if (error instanceof AxiosError) {
        errorMessage = error?.response?.data.messageResponse;
      }
      openNotificationWithIcon('error', {
        title: 'Depósito',
        content: errorMessage || 'Erro ao alterar o depósito!',
      });
    }
  };

  return (
    <Container>
      <h1>Alterar Depósito</h1>
      {deposit && (
        <Form
          size="large"
          labelCol={{ flex: '110px' }}
          labelAlign="left"
          wrapperCol={{ flex: 1 }}
          labelWrap
          colon={false}
          form={form}
          initialValues={deposit}
          validateMessages={validate}
          onFinish={handleSubmit}
        >
          <Form.Item
            name={['code']}
            label="Código"
            rules={[{ required: true }]}
            wrapperCol={{ span: 12 }}
            hasFeedback
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={['description']}
            label="Descrição"
            rules={[{ required: true }]}
            wrapperCol={{ span: 12 }}
            hasFeedback
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit">
            Salvar
          </Button>
        </Form>
      )}
    </Container>
  );
};

export default EditDeposits;
